            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">       
      <b-row style="width:100%">
        <b-col sm="12">
          <b-row  class="row-inputs">
            <p>Aquí se anulara la inclusión que se hizo  en el sistema.</p>  
            <br>
            <b-row style="width:100%">
              <sw-inputs
                :md="12" :lg="12"
                inputTabla="afiliado_inclusiones"
                inputCampo="nota_delete">
              </sw-inputs> 
            </b-row>          
          </b-row>
        </b-col>
      </b-row>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px">
        <b-row style="padding-top: 10px;">
          <b-col class="text-right">             
              <b-button  @click="save(false)" 
                :disabled="invalid"
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Anular
              </b-button>
          </b-col>
        </b-row> 
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import { ValidationObserver } from 'vee-validate'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  data()
  {
    return {
      nameAfiliado:''
    }
  },
  computed: {    
    ...mapState({
    })
  },
  async created()
  {
    await this.updateDataForm({data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    save(emit)
    {
      this.$emit('save', {save: emit, ftn: 'anularInclusionFtn'})
    },
  }
}
</script>
<style>
</style>